import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ArrowOutboundIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 15.89C22.45 15.89 22 16.34 22 16.89V20.56C22 21.36 21.35 22 20.56 22H3.44C2.64 22 2 21.35 2 20.56V3.44C2 2.64 2.65 2 3.44 2H7.11C7.66 2 8.11 1.55 8.11 1C8.11 0.45 7.66 0 7.11 0H3.44C1.54 0 0 1.54 0 3.44V20.55C0 22.45 1.54 23.99 3.44 23.99H20.55C22.45 23.99 23.99 22.45 23.99 20.55V16.88C23.99 16.33 23.54 15.88 22.99 15.88L23 15.89Z"
        fill={color}
      />
      <path
        d="M23 0H14.44C13.89 0 13.44 0.45 13.44 1C13.44 1.55 13.89 2 14.44 2H20.58L8.83999 13.74C8.44999 14.13 8.44999 14.76 8.83999 15.15C9.22999 15.54 9.85999 15.54 10.25 15.15L22 3.41V9.55C22 10.1 22.45 10.55 23 10.55C23.55 10.55 24 10.1 24 9.55V1C24 0.45 23.55 0 23 0Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ArrowOutboundIcon.displayName = 'ArrowOutboundIcon';
